module.exports = __webpack_public_path__ + "img/Select-Circle.2fb175c7.svg";